export default {
    "商务合作": "商务合作",
    "MANA商务合作": "MANA商务合作",
    "活动": "活动",
    "论坛 / 沙龙 / 讲座 / 演出 / 工作坊 / 展览 / 直播 /其他": "论坛 / 沙龙 / 讲座 / 演出 / 工作坊 / 展览 / 直播 /其他",
    "预约服务": "预约服务",
    "我要合作": "我要合作",
    "广告推广": "广告推广",
    "网站 / APP / 微信公众号": "网站 / APP / 微信公众号",
    "了解详情": "了解详情",
    "竞赛与征集": "竞赛与征集",
    "全案策划 / 征集及推广 / 评委及评选 / 活动及转化": "全案策划 / 征集及推广 / 评委及评选 / 活动及转化",
    "销售合作": "销售合作",
    "课程 / 票务 / 书籍": "课程 / 票务 / 书籍",
    "其它商务服务": "其它商务服务",
    "服务热线": "服务热线",
    "商务合作邮箱": "商务合作邮箱",
    "workTime": "(工作时间：工作日 9:30 a.m. - 6：00 p.m.)",
    "广告刊例": "广告刊例",
    "微信公众号": "微信公众号",
    "新媒体艺术站": "新媒体艺术站",
    "内容需经过审核，至少提前两周预约排期": "内容需经过审核，至少提前两周预约排期",
    "内容需经过审核": "内容需经过审核",
    "服务类型": "服务类型",
    "广告形式": "广告形式",
    "发布时长": "发布时长",
    "备注": "备注",
    "内容采编": "内容采编",
    "头条发布": "头条发布",
    "次条发布": "次条发布",
    "头条文末链接": "头条文末链接",
    "软文": "软文",
    "图文链接": "图文链接",
    "1次": "1次",
    "1周": "1周",
    "需提供素材": "需提供素材",
    "文字介绍、相关视频、动图或图片、涉及到的艺术家或团队介绍、赠票或衍生品服务（粉丝福利）": "文字介绍、相关视频、动图或图片、涉及到的艺术家或团队介绍、赠票或衍生品服务（粉丝福利）",
    "网站和APP": "网站和APP",
    "内容和素材需经过审核；了解更多信息请联系右侧人工客服咨询。": "内容和素材需经过审核；了解更多信息请联系右侧人工客服咨询。",
    "网站+APP首页": "网站+APP首页",
    "Banner第二、三帧（见下图A1）": "Banner第二、三帧（见下图A1）",
    "网站首页": "网站首页",
    "频道推荐第二位（见下图A2）": "频道推荐第二位（见下图A2）",
    "活动推荐第二位（见下图A3）": "活动推荐第二位（见下图A3）",
    "优秀创作者第二位（见下图A4）": "优秀创作者第二位（见下图A4）",
    "大于2M的图片素材（请确认已授权）、文字内容": "大于2M的图片素材（请确认已授权）、文字内容",
    "位置示意": "位置示意",
    "联系方式": "联系方式",
    "项目对接": "项目对接",
    "合作": "合作",
    "产商服务": "产商服务",
    "MANA产商服务": "MANA产商服务",
    "为企业和政府提供基于科技艺术产业链的咨询、资源整合以及整体解决方案服务；输出和定制具有“投入-产出”闭环逻辑和IP属性的内容型产品。": "为企业和政府提供基于科技艺术产业链的咨询、资源整合以及整体解决方案服务；输出和定制具有“投入-产出”闭环逻辑和IP属性的内容型产品。",
    "服务接洽": "服务接洽",
    "四大服务": "四大服务",
    "咨询顾问": "咨询顾问",
    "科技艺术生产效率赋能": "科技艺术生产效率赋能",
    "科技艺术场景与品牌赋能": "科技艺术场景与品牌赋能",
    "科技艺术产品与运营赋能": "科技艺术产品与运营赋能",
    "科技艺术战略与模型": "科技艺术战略与模型",
    "资源整合": "资源整合",
    "内容与创作者资源整合": "内容与创作者资源整合",
    "科技艺术产业链整合": "科技艺术产业链整合",
    "科技艺术教育培训资源整合": "科技艺术教育培训资源整合",
    "项目与资本资源整合": "项目与资本资源整合",
    "解决方案": "解决方案",
    "科技艺术新策略、新产品的规划与实施": "科技艺术新策略、新产品的规划与实施",
    "咨询-方案-资源-落地-运营的全案整合服务": "咨询-方案-资源-落地-运营的全案整合服务；",
    "长期战略型科技艺术项目的落地": "长期战略型科技艺术项目的落地；",
    "构建科技艺术产品体系和运营系统": "构建科技艺术产品体系和运营系统；",
    "产品输出": "产品输出",
    "服务产品": "服务产品",
    "基于屏幕的商业与公共空间数字艺术周期性策展": "基于屏幕的商业与公共空间数字艺术周期性策展",
    "数字艺术内容赋能展览展示": "数字艺术内容赋能展览展示",
    "科技艺术未来生活场景实验室": "科技艺术未来生活场景实验室",
    "场馆产品": "场馆产品",
    "沉浸式新媒体艺术主题系列乐园": "沉浸式新媒体艺术主题系列乐园",
    "科技艺术主题系列美术馆、博物馆": "科技艺术主题系列美术馆、博物馆",
    "城市产品": "城市产品",
    "科技艺术产业、文旅及商业园区（或综合体）": "科技艺术产业、文旅及商业园区（或综合体）",
    "科技艺术产业、商业及生活街区": "科技艺术产业、商业及生活街区",
    "城市科技艺术节庆活动系列产品": "城市科技艺术节庆活动系列产品",
    "市场&应用": "市场&应用",
    "城市活动": "城市活动",
    "艺术节": "艺术节",
    "竞赛": "竞赛",
    "活动周": "活动周",
    "社区服务": "社区服务",
    "乡镇活动": "乡镇活动",
    "城市空间": "城市空间",
    "交通枢纽": "交通枢纽",
    "广场公园": "广场公园",
    "街景河景": "街景河景",
    "商业空间": "商业空间",
    "文化复兴": "文化复兴",
    "文保数字化": "文保数字化",
    "IP研发": "IP研发",
    "节庆活动": "节庆活动",
    "文化场馆": "文化场馆",
    "文旅夜游": "文旅夜游",
    "景区赋能": "景区赋能",
    "内容整合": "",
    "内容与场景开发": "内容与场景开发",
    "运作系统整合": "运作系统整合",
    "样板场景打造": "样板场景打造",
    "园区/街区/产城": "园区/街区/产城",
    "新基建内容场景": "新基建内容场景",
    "智慧城市": "智慧城市",
    "城市更新": "城市更新",
    "新型产业园区": "新型产业园区",
    "其他服务请联系": "其他服务请联系",
    "关于MANA": "关于MANA",
    "MANA是全球科技艺术产业的整合服务平台。": "MANA是全球科技艺术产业的整合服务平台。",
    "基于全球的内容与创作者分享平台，聚集科技艺术专业及产业资源，提供产业链整合及增效服务。": "基于全球的内容与创作者分享平台，聚集科技艺术专业及产业资源，提供产业链整合及增效服务。",
    "为文创娱乐、商业文旅、会展节庆及城市乡村运营，研发下一代际科技艺术场景与服务产品。": "为文创娱乐、商业文旅、会展节庆及城市乡村运营，研发下一代际科技艺术场景与服务产品。",
    "联系邮箱": "联系邮箱",
    "了解更多信息请联系人工客服": "了解更多信息请联系人工客服",
    "项目对接服务": "项目对接服务",
    "如果您的项目想要对接MANA平台上的入驻团队，请前往": "如果您的项目想要对接MANA平台上的入驻团队，请前往",
    "板块发布需求": "板块发布需求",
    "资源对接": "资源对接",
    "推荐适配团队/作品": "推荐适配团队/作品",
    "我有需求": "我有需求"
}



// WEBPACK FOOTER //
// ./src/languages/cn/business.js